import EmbeddedRoutesView from './embedded_routes_view';

export default EmbeddedRoutesView;
